import restful from '@/utils/restful';
import * as names from '@/store/names';
import * as get from '@/store/store';

// Descriptores de una pieza del Diseño Instruccional: bloques de texto libre con su
// título, dentro de la tarjeta de la Actividad. Mismo patrón que los del Diseño
// (`instructional_design_descriptors`) y comparten SU catálogo de títulos
// (EgressProfileMatterDescriptor); lo que los separa es el `page_position` del título,
// que para la pieza es 4.
//
// El ancla son dos campos y sólo uno viene lleno: la pieza es la evaluación del Programa,
// y ésa vive en dos modelos según el nivel de la asignatura.
const state = {
    instructional_activity_descriptors: [],
    instructional_activity_descriptors_url: '/teaching/instructional-activity-descriptor'
}

const getters = {
    [names.INSTRUCTIONAL_ACTIVITY_DESCRIPTORS]: state => {
        if (!get.store.state.user) return [];
        return state.instructional_activity_descriptors
            .filter((x) => x.school == get.store.state.user.school)
            .sort(function (a, b) {
                if (a.order > b.order) return 1;
                if (a.order < b.order) return -1;
                return 0;
            });
    },
}

const mutations = {
    [names.MUTATE_INSTRUCTIONAL_ACTIVITY_DESCRIPTORS]: (state, instructional_activity_descriptors) => {
        instructional_activity_descriptors.forEach(element => {
            let index = state.instructional_activity_descriptors.findIndex(x => x.id == element.id);
            if (index != -1) state.instructional_activity_descriptors.splice(index, 1, element);
            else state.instructional_activity_descriptors.push(element);
        });
        state.instructional_activity_descriptors.sort(function (a, b) {
            return ((a.order < b.order) ? -1 : ((a.order > b.order) ? 1 : 0));
        });
    },
    [names.MUTATE_INSTRUCTIONAL_ACTIVITY_DESCRIPTOR]: (state, instructional_activity_descriptor) => {
        let index = state.instructional_activity_descriptors.findIndex(x => x.id == instructional_activity_descriptor.id);
        if (index != -1) state.instructional_activity_descriptors.splice(index, 1, instructional_activity_descriptor);
        else state.instructional_activity_descriptors.push(instructional_activity_descriptor);
        state.instructional_activity_descriptors.sort(function (a, b) {
            return ((a.order < b.order) ? -1 : ((a.order > b.order) ? 1 : 0));
        });
    },
    [names.MUTATE_DELETE_INSTRUCTIONAL_ACTIVITY_DESCRIPTOR]: (state, instructional_activity_descriptor_id) => {
        let index = state.instructional_activity_descriptors.findIndex(x => x.id == instructional_activity_descriptor_id);
        if (index != -1) state.instructional_activity_descriptors.splice(index, 1);
    },
}

const actions = {
    // payload: { matter_evaluation, egress_profile_matter_evaluation, matter,
    //            egress_profile_matter, descriptor }
    //
    // Por `matter` o `egress_profile_matter` llegan los de TODAS las piezas de la
    // asignatura: la pantalla del diseño los pide así, en una petición, en vez de una por
    // tarjeta. `descriptor` responde si un título sigue en uso en otra pieza; se usa al
    // borrar un bloque, para saber si el título quedó huérfano en el catálogo.
    [names.FETCH_INSTRUCTIONAL_ACTIVITY_DESCRIPTORS]: ({
        commit,
        state,
    }, payload = {}) => {
        const {
            matter_evaluation = null,
            egress_profile_matter_evaluation = null,
            matter = null,
            egress_profile_matter = null,
            descriptor = null,
        } = payload;
        return new Promise((resolve, reject) => {
            let arr = [];
            if (matter_evaluation != null)
                arr.push(`matter_evaluation=${matter_evaluation}`);
            if (egress_profile_matter_evaluation != null)
                arr.push(`egress_profile_matter_evaluation=${egress_profile_matter_evaluation}`);
            if (matter != null) arr.push(`matter=${matter}`);
            if (egress_profile_matter != null)
                arr.push(`egress_profile_matter=${egress_profile_matter}`);
            if (descriptor != null) arr.push(`descriptor=${descriptor}`);
            let query = arr.length > 0 ? `?${arr.join('&')}` : '';
            restful.GetAll(`${state.instructional_activity_descriptors_url}/${query}`)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_ACTIVITY_DESCRIPTORS, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.POST_INSTRUCTIONAL_ACTIVITY_DESCRIPTOR]: ({
        commit,
        state
    }, instructional_activity_descriptor) => {
        return new Promise((resolve, reject) => {
            restful.Post(`${state.instructional_activity_descriptors_url}/`, instructional_activity_descriptor)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_ACTIVITY_DESCRIPTOR, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.UPDATE_INSTRUCTIONAL_ACTIVITY_DESCRIPTOR]: ({
        commit,
        state
    }, instructional_activity_descriptor) => {
        return new Promise((resolve, reject) => {
            restful.Put(`${state.instructional_activity_descriptors_url}/${instructional_activity_descriptor.id}/`, instructional_activity_descriptor)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_ACTIVITY_DESCRIPTOR, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    // payload: { instructional_activity_descriptor_id, item }
    [names.PATCH_INSTRUCTIONAL_ACTIVITY_DESCRIPTOR]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve, reject) => {
            restful.Patch(`${state.instructional_activity_descriptors_url}/${payload.instructional_activity_descriptor_id}/`, payload.item)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_ACTIVITY_DESCRIPTOR, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.DELETE_INSTRUCTIONAL_ACTIVITY_DESCRIPTOR]: ({
        commit,
        state
    }, instructional_activity_descriptor_id) => {
        return new Promise((resolve, reject) => {
            restful.Delete(`${state.instructional_activity_descriptors_url}/${instructional_activity_descriptor_id}/`)
                .then(response => {
                    commit(names.MUTATE_DELETE_INSTRUCTIONAL_ACTIVITY_DESCRIPTOR, instructional_activity_descriptor_id);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};
